import { Pipe, PipeTransform } from '@angular/core';
import { arrayEmpty } from 'src/app/utils/array.utils';

@Pipe({
    name: 'arrayEmpty',
    standalone: false
})
export class ArrayEmptyPipe implements PipeTransform {

    transform(value: any): any {
        return arrayEmpty(value);
    }

}
